<div class="page-container">
  <div class="tabs-container">
    <div class="tab" [ngClass]="{ 'active': activeTab === tabTypes.Protocols }"
      (click)="doActiveTab(tabTypes.Protocols)">Protocoles</div>
    <div class="tab" [ngClass]="{ 'active': activeTab === tabTypes.Documents }"
      (click)="doActiveTab(tabTypes.Documents)">Documents</div>
  </div>

  <div class="page-content">
    <div class="tab-content" *ngIf="activeTab === tabTypes.Protocols">
      <div class="buttons-container">
        <frg-button (activated)="addProtocol()">Ajouter un protocole</frg-button>
      </div>

      <frg-table [keysBody]="protocolsTable" [keysColumn]="protocolsTableColumnTable" [isRowsClickable]="true"
        (onDblClickRow)="goToProtocolEdit($event)" tableButton1="assets/icons/trash.svg"
        (onClick1)="deleteProtocol($event)" isOkForDblClick="true" (onChangePage)="changePage($event)"
        (onSort)="sortProtocols($event)"></frg-table>
    </div>

    <div class="tab-content" *ngIf="activeTab === tabTypes.Documents">
      <frg-table [keysBody]="documentsTable" [keysColumn]="documentsTableColumnTable" [isRowsClickable]="true"
        (onDblClickRow)="openDocument($event)" isOkForDblClick="true" (onChangePage)="changePageDocument($event)"
        (onSort)="sortDocuments($event)"></frg-table>
    </div>
  </div>
</div>